export default __webpack_public_path__ + "static/media/Rita_Segurado_2.971a65e5.png";